import Axios from "axios";
import { getDomain } from "../../../Utilities/utils";
import { GET_FORMIK_VALUES_API_ENDPOINT } from "../../../PersonalAccident/apiConfig";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

export const getFormikValues = async (formikValuesId, formik) => {
  try {
    const domain = getDomain();
    const response = await axiosInstance.get(
      `${GET_FORMIK_VALUES_API_ENDPOINT}/${formikValuesId}/`
    );
    console.log("get formik values api response", response);
    formik.setValues(response.data.formik_values);
  } catch (error) {
    console.log("error", error);
  }
};
